export default __webpack_public_path__ + "static/media/about.d8f393df.png";